export default {"src":"/_next/static/media/next-arrow-step-two-image.6e9f39ab.svg","height":70,"width":71,"blurWidth":0,"blurHeight":0};